/**
 * DevExtreme (esm/__internal/grids/new/grid_core/selection/public_methods.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export function PublicMethods(GridCore) {
    return class extends GridCore {
        isCardSelected(key) {
            return this.selectionController.isCardSelected(key)
        }
        getSelectedCardKeys() {
            return this.selectionController.getSelectedCardKeys()
        }
        getSelectedCardsData() {
            return this.selectionController.getSelectedCardsData()
        }
        selectCards(keys) {
            let preserve = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : false;
            return this.selectionController.selectCards(keys, preserve)
        }
        deselectCards(keys) {
            return this.selectionController.deselectCards(keys)
        }
        selectCardsByIndexes(indexes) {
            return this.selectionController.selectCardsByIndexes(indexes)
        }
        deselectCardsByIndexes(indexes) {
            return this.selectionController.deselectCardsByIndexes(indexes)
        }
        selectAll() {
            return this.selectionController.selectAll()
        }
        deselectAll() {
            return this.selectionController.deselectAll()
        }
        clearSelection() {
            this.selectionController.clearSelection()
        }
    }
}
